import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import cn from "classnames";
import { push } from "connected-react-router";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import qs from "query-string";
import { Link } from "react-router-dom";
import { getTip } from "utils/helpers";

import { IRootState } from "reducers";
import { Actions as appActions } from "reducers/app";

import CardProduct from "components/CardProduct";
import Select from "components/Select";
import Pagination from "components/Pagination";

import * as catalogAPI from "api/catalog";

import LoupeImg from "img/search.svg";

interface ILists {
  categories: any[];
  carClasses: any[];
  topOffers: any[];
}

interface IProps {
  goTo: any;
  tips: { [key: string]: string };
  toggleUIBlocking: (payload: boolean) => void;
}

interface IQueryParams {
  page: string;
}

const CatalogPage: React.FC<IProps & RouteComponentProps<IQueryParams>> = ({
  match: {
    params: { page }
  },
  location: { search },
  goTo,
  tips,
  toggleUIBlocking
}) => {
  const [lists, setLists] = useState<ILists>({
    categories: [],
    carClasses: [],
    topOffers: []
  });

  const queryParams = qs.parse(search);
  const [searchString, setSearchString] = useState(queryParams.query || "");

  const currentPage = parseInt(page, 10);
  const selectedCategory = parseInt(queryParams.category as string, 10);
  const selectedClass = parseInt(queryParams.class as string, 10);
  const selectedOffer = parseInt(queryParams.offer as string, 10);
  const selectedSort = queryParams.sort as string;
  const sortOrderDown = (queryParams.order as string) === "down";

  const [showChildren, setShowChildren] = useState<number | undefined>(undefined);

  useEffect(() => {
    catalogAPI.getLists().then((response: any) => {
      if (response.success) {
        setLists(response.data);
        response.data.categories.some((i: any) => i.id === selectedCategory) ?
        setShowChildren(response.data.categories.find((i: any) => i.id === selectedCategory).id)
        : response.data.categories.map((i: any) => {
          i.children.map((item: any) => {
            if (item.id === selectedCategory) {
              setShowChildren(i.id);
            }
          })
        })

      } else {
        toastr.error("Ошибка получения данных", response.error);
      }
    });
  }, []);

  const [popularProducts, setPopularProducts] = useState<any>({
    data: [],
    page: 0,
    pageCount: 0
  });

  useEffect(() => {
    toggleUIBlocking(true);

    setSearchString(
      typeof queryParams.query === "string" ? queryParams.query : ""
    );

    catalogAPI
      .catalogSearch(currentPage)({ ...queryParams })
      .then((response: any) => {
        if (response.success) {
          setPopularProducts(response);

          if (response.data.length === 0) {
            if (response.page !== 0) {
              goTo({
                pathname: "/home/catalog/page/0",
                search: qs.stringify(queryParams)
              });
            }
            // toastr.warning(getTip(7)(tips), '');
          }
        } else {
          toastr.error("Ошибка загрузки продуктов", response.error);
          toggleUIBlocking(false);
        }
        toggleUIBlocking(false);
      });
  }, [
    selectedCategory,
    queryParams.query,
    currentPage,
    selectedSort,
    sortOrderDown,
    selectedClass,
    selectedOffer
  ]);

  const updateQueryParams = (params: any) => {
    // Update query string in url
    const query = { ...queryParams, ...params };
    goTo({ search: qs.stringify(query) });
  };

  const handleSearch = () => {
    updateQueryParams({ query: searchString });
  };

  const handleChangeClass = (value: number | undefined) => {
    updateQueryParams({ class: value });
  };

  const handleChangeOffer = (value: number | undefined) => {
    updateQueryParams({ offer: value });
  };

  const handleShowChildren = (id: number) => {
    setShowChildren(id);
  };

  const calculateLink = (params: { [key: string]: any }) => ({
    search: qs.stringify({ ...queryParams, ...params })
  });
  return (
    <div className="container">
      <div className="row">
        <input id="filter-spoiler" type="checkbox" />
        <aside className="col-12 col-sm-4 col-xl-3 py-sm-0 catalog-page-aside">
          <nav className="card">
            <div className="search-box d-sm-none">
              <input
                type="text"
                placeholder="Поиск по названию товара или категории товара..."
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
                onKeyPress={e => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
              <button className="btn" onClick={handleSearch}>
                <img src={LoupeImg} />
              </button>
            </div>

            <span className="title">
              <Link to="/home/catalog">Каталог</Link>
            </span>
            <ul>
              {lists.categories.map(category => (
                <li
                  className={cn({ active: category.id === selectedCategory })}
                  key={category.id}
                  onClick={() => handleShowChildren(category.id)}
                >
                  <Link
                    to={calculateLink({
                      category: category.id,
                      query: undefined
                    })}
                  >
                    {category.name}
                  </Link>

                  {category.id === showChildren &&
                    category.children.length !== 0 && (
                      <ul className="level-2">
                        {category.children.map((subCategory: any) => (
                          <li
                            className={cn({
                              active: subCategory.id === selectedCategory
                            })}
                            key={subCategory.id}
                          >
                            <Link
                              to={calculateLink({
                                category: subCategory.id,
                                query: undefined
                              })}
                            >
                              {subCategory.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                </li>
              ))}
            </ul>

            <span className="title">Класс авто:</span>
            <Select
              value={selectedClass}
              options={lists.carClasses}
              onChange={handleChangeClass}
            />

            <span className="title">Спецпредложения:</span>
            <Select
              value={selectedOffer}
              options={lists.topOffers}
              onChange={handleChangeOffer}
            />
          </nav>
          <label className="d-sm-none filter-spoiler" htmlFor="filter-spoiler">
            <span className="hide">Свернуть фильтры</span>
            <span className="show">Открыть фильтры</span>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 5L5 1L1 5"
                stroke="#708090"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </label>
        </aside>
        <div className="col-12 col-sm-8 col-xl-9 prod px-0">
          <div className="row w-100 mx-0 d-flex justify-content-between align-items-center kost">
            <div className="col-12 d-none d-sm-flex search-box">
              <input
                type="text"
                placeholder="Поиск по названию товара или категории товара..."
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
                onKeyPress={e => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
              <button className="btn" onClick={handleSearch}>
                <img src={LoupeImg} />
              </button>
            </div>
            <div className="col-12 prod__title pt-3 pt-sm-0">
              {/* <h1 className="category__h1">Охрана квартиры</h1> */}
              <h1 className="category__h1" />
              <div className="sort pull-xs-right">
                <Link
                  to={calculateLink({
                    sort: "price",
                    order: sortOrderDown ? "up" : "down"
                  })}
                  className={cn({
                    active: selectedSort === "price",
                    down: sortOrderDown
                  })}
                  id="price"
                >
                  По стоимости
                  <svg
                    className="sort__icon"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 5L5 1L1 5"
                      stroke="#212121"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>

                <Link
                  to={calculateLink({
                    sort: "bonus",
                    order: sortOrderDown ? "up" : "down"
                  })}
                  className={cn({
                    active: selectedSort === "bonus",
                    down: sortOrderDown
                  })}
                  id="bonus"
                >
                  По бонусу
                  <svg
                    className="sort__icon"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 5L5 1L1 5"
                      stroke="#212121"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>

                <Link
                  to={calculateLink({
                    sort: "name",
                    order: sortOrderDown ? "up" : "down"
                  })}
                  className={cn({
                    active: selectedSort === "name",
                    down: sortOrderDown
                  })}
                  id="name"
                >
                  По названию
                  <svg
                    className="sort__icon"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 5L5 1L1 5"
                      stroke="#212121"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            {popularProducts.data.length === 0 &&
              popularProducts.success &&
              getTip(7)(tips)}
            <div className="row catalog-products">
              {popularProducts.data.map((item: any, index: number) => (
                <CardProduct
                  {...item}
                  defaultClassId={selectedClass}
                  key={item.id}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {popularProducts.data.length !== 0 && (
        <Pagination
          baseUrl={"/home/catalog/page"}
          queryParams={search}
          page={popularProducts.page}
          pageCount={popularProducts.pageCount}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ app: { tips } }: IRootState) => ({
  tips
});

const actions = {
  goTo: push,
  toggleUIBlocking: appActions.toggleUIBlocking
};

export default connect(
  mapStateToProps,
  actions
)(CatalogPage);
